import type { LayoutType } from 'types';
import type { TemplateFormsState } from '../index';
import { initialItem } from './addNewSection';
import { getStartPos } from 'utils/section/gridUtils';

interface Payload {
  name: string;
  position: { x: number; y: number };
  layoutType: LayoutType;
  subTabId?: string | null;
}

export const removeSectionItem = (state: TemplateFormsState, { payload }: { payload: Payload }) => {
  const { name, position, layoutType, subTabId } = payload;
  const sections = state[layoutType].sections;

  const sectionIndex = sections.findIndex((section) => section.name === name);
  if (sectionIndex === -1) return;

  const targetX = position.x;
  const targetY = position.y;
  const targetSubTab = subTabId ?? null;

  const result = sections[sectionIndex].items.map((item) => {
    const itemX = getStartPos(item.x);
    const itemY = getStartPos(item.y);
    const itemSubTab = item.subTabId ?? null;
    if (itemX === targetX && itemY === targetY && itemSubTab === targetSubTab) {
      const placeholder = {
        ...initialItem,
        x: String(targetX),
        y: String(targetY),
        subTabId: targetSubTab,
      };
      return placeholder;
    }
    return item;
  });

  state[layoutType].sections[sectionIndex].items = result;
};
